import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: IndexComponent,
})

function IndexComponent() {
  // Redirect to guest PIN entry by default
  return <Navigate to="/guest/pin" search={{ pin: undefined }} />
}
